import { LABELS } from '@/constants/common/message.constants'

import { type PartnerEntity } from '../../aspida/@types'

/**
 * 計上基準（VOC_PJ-55 #3516）。
 * Partner.defaultIncomeRecordingDateType / defaultExpenseRecordingDateType / expenseRecordingDateType
 * Customer.incomeRecordingDateType の値型。
 */
export type RecordingDateType = NonNullable<
  PartnerEntity['defaultIncomeRecordingDateType']
>

export const RECORDING_DATE_TYPE = {
  /** 発日 */
  SHIPPING_DATE: 'SHIPPING_DATE',
  /** 着日 */
  DELIVERY_DATE: 'DELIVERY_DATE'
} as const satisfies Record<RecordingDateType, RecordingDateType>

export const RECORDING_DATE_TYPE_LABEL = {
  [RECORDING_DATE_TYPE.SHIPPING_DATE]: LABELS.RECORDING_DATE_TYPE_SHIPPING,
  [RECORDING_DATE_TYPE.DELIVERY_DATE]: LABELS.RECORDING_DATE_TYPE_DELIVERY
} as const satisfies Record<RecordingDateType, string>

export function getRecordingDateTypeLabel(type: RecordingDateType): string {
  return RECORDING_DATE_TYPE_LABEL[type]
}
